import { NUMBER_VALIDATION_REGEX } from 'constants/AppConstants';

/**
 * Used for performing particular validation for the field and field value received
 * @param {string} fieldName - name of field whose value is to be validated
 * @param {string} fieldValue - value to be validated
 */
const validateUserInput = (fieldName, fieldValue) => {
  switch (fieldName) {
    case 'firstName':
    case 'lastName':
    case 'title': {
      if (!fieldValue) {
        return 'The field is empty.';
      }
      return '';
    }
    case 'countryId': {
      if (!fieldValue) {
        return 'Not a valid country code.';
      }
      return '';
    }
    case 'phoneNumber': {
      if (!fieldValue) {
        return 'The field is empty.';
      }
      if (!NUMBER_VALIDATION_REGEX.test(fieldValue)) {
        return 'The field expects a whole number.';
      }
      return '';
    }
    default:
      return '';
  }
};

export default validateUserInput;
